module.exports = __webpack_public_path__ + "static/media/difc.14d298e2.png";